import { useEffect } from 'react';
import { useTechniciansStore } from '../store/technicians';

export function useTechnicians() {
  const technicians = useTechniciansStore((s) => s.technicians);
  const load = useTechniciansStore((s) => s.load);

  useEffect(load, [load]);

  return technicians;
}
